import { PipeSeriesRepository } from "@imi-ernd-be/hyselect-engine";
import { PipeSeriesPreference } from "@src/core/api/pipeSeriesPreference";
import { assert } from "radashi";
import { toArray } from "../vector";

export function setExistingPipeSeries(
  repository: PipeSeriesRepository,
  selection: PipeSeriesPreference | undefined,
) {
  const { pipes, pipeSeries } = selection ?? {};
  repository.fillPipeSeries();
  const allSeries = toArray(repository.getPipeSeries());
  assert(allSeries.length > 0, "No pipe series available");

  const defaultSeries = allSeries.find((s) => s.default) ?? allSeries[0];
  const selectedSeries =
    allSeries.find((s) => s.id === pipeSeries) || defaultSeries;

  const allPipes = toArray(selectedSeries.getPipesList());
  assert(allPipes.length > 0, "No pipes available in the selected series");
  const defaultPipe = allPipes.find((p) => p.default) || allPipes[0];
  const selectedPipe = toArray(selectedSeries.getPipesList()).find(
    (p) => p.id === pipes,
  );

  selectedSeries.setPipe(selectedPipe || defaultPipe);
  repository.setSerie(selectedSeries);
}
